import { create } from 'zustand'

export interface BrandingState {
  logoUrl: string | null
  companyName: string
  faviconUrl: string | null
  primaryColor: string
  setLogo: (url: string | null) => void
  setCompanyName: (name: string) => void
  setFavicon: (url: string | null) => void
  setPrimaryColor: (color: string) => void
  setBranding: (branding: Partial<Omit<BrandingState, 'setLogo' | 'setCompanyName' | 'setFavicon' | 'setPrimaryColor' | 'setBranding'>>) => void
}

export const useBrandingStore = create<BrandingState>((set) => ({
  logoUrl: null,
  companyName: 'BizFirst AI',
  faviconUrl: null,
  primaryColor: '#309B48', // Default BizFirst green

  setLogo: (url) => set({ logoUrl: url }),
  setCompanyName: (name) => set({ companyName: name }),
  setFavicon: (url) => set({ faviconUrl: url }),
  setPrimaryColor: (color) => set({ primaryColor: color }),
  setBranding: (branding) => set(branding),
}))
